(function() {
  'use strict';

  var STORAGE_KEY = 'mobigo_wishlist';

  // --- Core wishlist functions ---

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function isInWishlist(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function addToWishlist(handle) {
    var list = getWishlist();
    if (list.indexOf(handle) === -1) {
      list.push(handle);
      saveWishlist(list);
    }
  }

  function removeFromWishlist(handle) {
    var list = getWishlist();
    var index = list.indexOf(handle);
    if (index !== -1) {
      list.splice(index, 1);
      saveWishlist(list);
    }
  }

  function toggleWishlist(handle) {
    if (isInWishlist(handle)) {
      removeFromWishlist(handle);
      return false;
    } else {
      addToWishlist(handle);
      return true;
    }
  }

  // --- Update header wishlist count ---

  function updateWishlistCount() {
    var count = getWishlist().length;
    var badges = document.querySelectorAll('.wishlist-count');
    badges.forEach(function(badge) {
      badge.textContent = count;
    });
    var bubbles = document.querySelectorAll('.wishlist-bubble');
    bubbles.forEach(function(bubble) {
      bubble.style.display = count > 0 ? '' : 'none';
    });
  }

  // --- Initialize hearts on product cards ---

  function initHearts() {
    var hearts = document.querySelectorAll('[data-wishlist-handle]');
    hearts.forEach(function(heart) {
      var handle = heart.getAttribute('data-wishlist-handle');

      // Set initial state
      if (isInWishlist(handle)) {
        heart.classList.add('is-active');
      } else {
        heart.classList.remove('is-active');
      }

      // Remove old listeners by cloning
      var newHeart = heart.cloneNode(true);
      heart.parentNode.replaceChild(newHeart, heart);

      newHeart.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var added = toggleWishlist(handle);
        if (added) {
          newHeart.classList.add('is-active');
        } else {
          newHeart.classList.remove('is-active');
        }
        updateWishlistCount();
      });
    });
  }

  // --- Wishlist page rendering ---

  function renderWishlistPage() {
    var container = document.getElementById('wishlist-grid');
    var emptyMsg = document.getElementById('wishlist-empty');
    if (!container) return;

    var list = getWishlist();

    if (list.length === 0) {
      container.innerHTML = '';
      if (emptyMsg) emptyMsg.style.display = '';
      return;
    }

    if (emptyMsg) emptyMsg.style.display = 'none';
    container.innerHTML = '<p class="wishlist-loading">Loading your wishlist...</p>';

    var promises = list.map(function(handle) {
      return fetch('/products/' + handle + '.json')
        .then(function(res) {
          if (!res.ok) throw new Error('Not found');
          return res.json();
        })
        .then(function(data) { return data.product; })
        .catch(function() { return null; });
    });

    Promise.all(promises).then(function(products) {
      var validProducts = products.filter(function(p) { return p !== null; });

      if (validProducts.length === 0) {
        container.innerHTML = '';
        if (emptyMsg) emptyMsg.style.display = '';
        return;
      }

      var html = validProducts.map(function(product) {
        var image = product.image ? product.image.src : '';
        var price = (product.variants[0].price / 1).toFixed(2);
        var comparePrice = product.variants[0].compare_at_price;
        var savings = comparePrice ? ((comparePrice - product.variants[0].price) / 1).toFixed(2) : null;

        var priceHtml = '<span class="wishlist-card__price">&pound;' + price + '</span>';
        if (comparePrice) {
          priceHtml += '<div class="wishlist-card__price-meta">';
          priceHtml += '<span class="wishlist-card__compare">&pound;' + (comparePrice / 1).toFixed(2) + '</span>';
          priceHtml += '<span class="wishlist-card__save">Save &pound;' + savings + '</span>';
          priceHtml += '</div>';
        }

        return '<div class="wishlist-card" data-handle="' + product.handle + '">' +
          '<button class="wishlist-card__remove" data-remove-handle="' + product.handle + '" aria-label="Remove from wishlist">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
          '</button>' +
          '<a href="/products/' + product.handle + '" class="wishlist-card__media">' +
            (image ? '<img src="' + image + '&width=600" alt="' + product.title + '" class="wishlist-card__img" loading="lazy">' : '') +
          '</a>' +
          '<div class="wishlist-card__body">' +
            '<h3 class="wishlist-card__title"><a href="/products/' + product.handle + '">' + product.title + '</a></h3>' +
            '<div class="wishlist-card__price-row">' + priceHtml + '</div>' +
            '<a href="/products/' + product.handle + '" class="wishlist-card__cta button button-secondary">View product</a>' +
          '</div>' +
        '</div>';
      }).join('');

      container.innerHTML = html;

      // Bind remove buttons
      container.querySelectorAll('[data-remove-handle]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var handle = btn.getAttribute('data-remove-handle');
          removeFromWishlist(handle);
          var card = btn.closest('.wishlist-card');
          if (card) {
            card.style.transition = 'opacity 0.3s';
            card.style.opacity = '0';
            setTimeout(function() {
              card.remove();
              updateWishlistCount();
              if (getWishlist().length === 0 && emptyMsg) {
                emptyMsg.style.display = '';
              }
            }, 300);
          }
          // Also update any hearts on page
          initHearts();
        });
      });
    });
  }

  // --- Init ---

  function init() {
    initHearts();
    updateWishlistCount();
    renderWishlistPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when Shopify sections reload (theme editor)
  document.addEventListener('shopify:section:load', function() {
    setTimeout(init, 100);
  });

  // Expose for external use
  window.MobigoWishlist = {
    get: getWishlist,
    add: addToWishlist,
    remove: removeFromWishlist,
    toggle: toggleWishlist,
    isIn: isInWishlist,
    refresh: init
  };
})();
